module.exports = __webpack_public_path__ + "static/media/Arrow-left.e2b88920.svg";